import React, { memo } from 'react';

import Warrant from 'components/Warrant';

const KingWarrant = memo(({ textWithLeftAlignment }) => (
  <Warrant
    armsUrl="https://waitrose-prod.scene7.com/is/image/waitroseprod/king?$Waitrose-Image-Preset-95$"
    byAppointmentTo="His Majesty The King"
    textWithLeftAlignment={textWithLeftAlignment}
  />
));

KingWarrant.displayName = 'KingWarrant';

export default KingWarrant;
